import { render, staticRenderFns } from "./sharePoster.vue?vue&type=template&id=38034694&scoped=true&"
import script from "./sharePoster.vue?vue&type=script&lang=js&"
export * from "./sharePoster.vue?vue&type=script&lang=js&"
import style0 from "./sharePoster.vue?vue&type=style&index=0&lang=less&"
import style1 from "./sharePoster.vue?vue&type=style&index=1&id=38034694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38034694",
  null
  
)

export default component.exports